import { createAction } from '@reduxjs/toolkit'

import { SnackbarMessage, SnackbarOptions } from 'types/GlobalSnackbar'

// toggleSnackbarOpen
export const open = createAction<{
  message: SnackbarMessage
  options?: SnackbarOptions
}>('toggle_snackbar_open')

// toggleSnackbarClosed
export const close = createAction('toggle_snackbar_closed')
